import React, { useState, useEffect } from "react";
import { FaChevronDown, FaChevronUp, FaEllipsisV } from "react-icons/fa";
import { FiRefreshCcw } from "react-icons/fi";

import {
  Modal,
  Button,
  Table,
  Tabs,
  Tab,
  Form,
  Dropdown,
} from "react-bootstrap";
import {
  FaCheck,
  FaEdit,
  FaPen,
  FaSave,
  FaTimesCircle,
  FaToggleOff,
  FaToggleOn,
} from "react-icons/fa";
import { useServicabilitySettings } from "../../customHooks/ServicabilitySettings/useServicabilitySettings";
import "./ServicabilitySettings.css";

const ServicabilitySettings = ({
  storeDetails,
  handleServiceabilityDetails,
}) => {
  const talonProps = useServicabilitySettings();
  const {
    loader,
    servicabilities,
    // handleDropdownChange,
    handleSearchChange,
    selectedOption,
    searchValue,
    handleClearFilters,
    handleModalToggle,
    isModalOpen,
    serviceableCities,
    nonServiceableCities,

    handleBulkEdit,
    bulkDeliveryCharge,
    setBulkDeliveryCharge,
    selectedCities,

    cityDeliveryCharges,
    setCityDeliveryCharges,

    handleCheckboxChange,
    handleEdit,
    handleSaveEdit,
    editingCity,
    hoveredCity,
    setHoveredCity,

    handleExportImport,
    modalState,
    handleImport,
    importedFile,
    importedLocationsSummary,
    updateServiceability,
    downloadSampleCSV,
    expandedStates,
    handleStateToggle,
    handleSelectAllCities,
    selectAllState,
    showBulkEditPanel,
    setShowBulkEditPanel,
    pendingSave,
    setPendingSave,
    handleUpdateCityDeliveryCharge,
    setEditingCity,

    selectedState,
    selectedCity,
    selectedCityCode,
    handleStateChange,
    handleCityChange,
  } = talonProps;

  const filteredStates = selectedState
    ? [selectedState]
    : Object.keys(serviceableCities);

  const getFilteredCities = (state) => {
    const cities = serviceableCities[state] || [];

    return selectedCity
      ? cities.filter((cityObj) => cityObj.city === selectedCity)
      : cities;
  };

  const safeImportedLocationsSummary = importedLocationsSummary || {
    passed: 0,
    failed: 0,
  };

  return (
    <div>
      <div className="form-group">
        <label>
          {/* <span style={{ fontSize: "17px" }}>Serviceability</span> */}
          <h5 className="storetitle pt-2">
            Serviceability and Delivery Charges
          </h5>
        </label>
        <div className="borderup"></div>
        <div className="serviceHeader">
          <div className="row d-flex justify-content-center align-items-center mb-2">
            <label style={{ fontSize: "15px" }}>Select Serviceability</label>
            <div
              className="col-2"
              style={{ display: "flex", alignItems: "center" }}
            >
              <input
                type="radio"
                name="serviceability"
                checked={
                  storeDetails.ServiceabilityAndDeliveryCharges
                    ?.is_all_india_serviceable
                }
                onChange={() => {
                  handleServiceabilityDetails(
                    "ServiceabilityAndDeliveryCharges",
                    "is_all_india_serviceable",
                    true
                  );
                }}
                style={{ marginRight: "10px", marginBottom: "3px" }}
              />
              <label>Is PAN India Serviceable?</label>
            </div>

            <div
              className="col"
              style={{
                display: "flex",
                alignItems: "center",
                paddingLeft: "0px",
              }}
            >
              <input
                type="radio"
                name="serviceability"
                checked={
                  !storeDetails.ServiceabilityAndDeliveryCharges
                    ?.is_all_india_serviceable
                }
                onChange={() => {
                  handleServiceabilityDetails(
                    "ServiceabilityAndDeliveryCharges",
                    "is_all_india_serviceable",
                    false
                  );
                }}
                style={{ marginRight: "10px" }}
              />
              <label style={{ marginRight: "8px" }}>State/City Specific</label>

              {!storeDetails.ServiceabilityAndDeliveryCharges
                ?.is_all_india_serviceable && (
                <div style={{ marginLeft: "auto" }}>
                  <Dropdown>
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                      Export/Import
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item
                        onClick={() => handleExportImport("export_serviceable")}
                      >
                        Export Serviceable Cities
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() =>
                          handleExportImport("export_non_serviceable")
                        }
                      >
                        Export Non Serviceable Cities
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => handleExportImport("import_serviceable")}
                      >
                        Import Serviceable Cities
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              )}
            </div>
          </div>
          {!storeDetails.ServiceabilityAndDeliveryCharges
            ?.is_all_india_serviceable && (
            <div className="edit-form">
              <div className="row align-items-end mb-3">
                <div className="col-2">
                  <label className="formLabels mb-1">State</label>
                  <select
                    className="form-select"
                    value={selectedState}
                    onChange={handleStateChange}
                  >
                    <option value="">Select</option>
                    {Object.keys(serviceableCities).map((state) => (
                      <option key={state} value={state}>
                        {state}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-2">
                  <label className="formLabels mb-1">City</label>
                  <select
                    className="form-select"
                    value={selectedCity}
                    onChange={handleCityChange}
                    disabled={!selectedState}
                  >
                    <option value="">Select</option>
                    {selectedState &&
                      serviceableCities[selectedState]?.map((cityObj) => (
                        <option key={cityObj.city} value={cityObj.city}>
                          {cityObj.city}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="col-2">
                  <label className="formLabels mb-1">City Code</label>
                  <input
                    type="text"
                    className="form-control"
                    value={selectedCityCode}
                    readOnly
                    placeholder="City code"
                  />
                </div>

                <div className="col-2">
                  <button
                    onClick={handleClearFilters}
                    style={{
                      padding: "6px 10px",
                      backgroundColor: "#0DCAF0C7",
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                      cursor: "pointer",
                      fontWeight: "500",
                      marginBottom: "2px",
                    }}
                  >
                    Clear Filters
                  </button>
                </div>

                <div className="col d-flex flex-column align-items-end">
                  <div
                    className="d-flex"
                    style={{ gap: "10px", position: "relative" }}
                  >
                    {/* Serviceability Button */}
                    <button
                      style={{
                        padding: "5px 10px",
                        backgroundColor: "#0DCAF0C7",
                        color: "white",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                        fontWeight: "500",
                      }}
                      onClick={() => {
                        setShowBulkEditPanel((prev) =>
                          prev === "serviceability" ? null : "serviceability"
                        );
                      }}
                    >
                      Serviceability
                    </button>

                    {/* Delivery Charges Button and Modal */}
                    <div style={{ position: "relative" }}>
                      <button
                        style={{
                          padding: "5px 10px",
                          backgroundColor: "#0DCAF0C7",
                          color: "white",
                          border: "none",
                          borderRadius: "4px",
                          cursor: "pointer",
                          fontWeight: "500",
                        }}
                        onClick={() => {
                          setShowBulkEditPanel((prev) =>
                            prev === "delivery" ? null : "delivery"
                          );
                        }}
                      >
                        Delivery Charges
                      </button>

                      {showBulkEditPanel === "delivery" && (
                        <div
                          style={{
                            position: "absolute",
                            top: "110%",
                            right: 0,
                            backgroundColor: "#ffffff",
                            border: "1px solid #e0e0e0",
                            borderRadius: "8px",
                            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                            padding: "16px",
                            zIndex: 1000,
                            minWidth: "250px",
                          }}
                        >
                          {/* Close Icon */}
                          <button
                            onClick={() => setShowBulkEditPanel(null)}
                            style={{
                              position: "absolute",
                              top: "8px",
                              right: "8px",
                              background: "transparent",
                              border: "none",
                              fontSize: "16px",
                              cursor: "pointer",
                              color: "#999",
                            }}
                            aria-label="Close"
                          >
                            &times;
                          </button>

                          <div
                            style={{
                              marginBottom: "10px",
                              fontWeight: "600",
                              fontSize: "14px",
                              color: "#333",
                            }}
                          >
                            Set Delivery Charge
                          </div>

                          <input
                            type="number"
                            min="0"
                            placeholder="Enter delivery charge"
                            value={bulkDeliveryCharge}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (Number(value) >= 0 || value === "") {
                                setBulkDeliveryCharge(value);
                              }
                            }}
                            style={{
                              padding: "8px",
                              borderRadius: "6px",
                              border: "1px solid #ccc",
                              fontSize: "14px",
                              width: "100%",
                              marginBottom: "12px",
                            }}
                          />

                          <button
                            onClick={() => {
                              if (Number(bulkDeliveryCharge) < 0) {
                                alert("Delivery charge cannot be negative.");
                                return;
                              }
                              handleBulkEdit("delivery");
                              setShowBulkEditPanel(null);
                            }}
                            style={{
                              padding: "8px 12px",
                              backgroundColor:
                                selectedCities.length === 0
                                  ? "#ccc"
                                  : "#198754",
                              color: "#fff",
                              border: "none",
                              borderRadius: "6px",
                              cursor:
                                selectedCities.length === 0
                                  ? "not-allowed"
                                  : "pointer",
                              fontWeight: "500",
                              width: "100%",
                            }}
                          >
                            Update
                          </button>
                        </div>
                      )}

                      {showBulkEditPanel === "serviceability" && (
                        <div
                          style={{
                            position: "absolute",
                            top: "110%",
                            right: 0,
                            backgroundColor: "#ffffff",
                            border: "1px solid #e0e0e0",
                            borderRadius: "8px",
                            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                            padding: "16px",
                            zIndex: 1000,
                            minWidth: "250px",
                          }}
                        >
                          {/* Close Icon */}
                          <button
                            onClick={() => setShowBulkEditPanel(null)}
                            style={{
                              position: "absolute",
                              top: "8px",
                              right: "8px",
                              background: "transparent",
                              border: "none",
                              fontSize: "16px",
                              cursor: "pointer",
                              color: "#999",
                            }}
                            aria-label="Close"
                          >
                            &times;
                          </button>

                          <div
                            style={{
                              fontWeight: "600",
                              fontSize: "14px",
                              color: "#333",
                              marginBottom: "12px",
                            }}
                          >
                            Mark selected cities as <strong>Serviceable</strong>
                          </div>

                          <button
                            onClick={() => handleBulkEdit("serviceability")}
                            style={{
                              padding: "8px 12px",
                              backgroundColor:
                                selectedCities.length === 0
                                  ? "#ccc"
                                  : "#198754",
                              color: "#fff",
                              border: "none",
                              borderRadius: "6px",
                              cursor:
                                selectedCities.length === 0
                                  ? "not-allowed"
                                  : "pointer",
                              fontWeight: "500",
                              width: "100%",
                            }}
                          >
                            Update
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="serviceContent">
        {!storeDetails.ServiceabilityAndDeliveryCharges
          ?.is_all_india_serviceable && (
          <>
            <div className="edit-form">
              {modalState === "servicebaility_summary" ? (
                <>
                  <div>
                    <Table
                      // style={{ width: "60% !important" }}
                      bordered
                      hover
                      responsive
                    >
                      <tbody>
                        {filteredStates.length > 0 ? (
                          filteredStates.map((state) => (
                            <React.Fragment key={state}>
                              <tr
                                style={{
                                  background: "#f0f0f0",
                                  // fontWeight: "bold",
                                  padding: "10px 15px",
                                }}
                                onClick={(e) => handleStateToggle(state, e)}
                              >
                                <td colSpan="4">
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      cursor: "pointer",
                                    }}
                                  >
                                   
                                    {showBulkEditPanel && (
                                      <Form.Check
                                        type="checkbox"
                                        checked={
                                          getFilteredCities(state).every(
                                            (area) =>
                                              selectedCities.includes(
                                                `${state}-${area.city}`
                                              )
                                          ) || selectAllState[state]
                                        }
                                        onChange={() =>
                                          handleSelectAllCities(state, true)
                                        }
                                        label=""
                                        style={{ marginRight: "15px" }}
                                        className="custom-dark-checkbox"
                                      />
                                    )}
                                    <div
                                      className="col-1"
                                      style={{
                                        textAlign: "left",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {state}
                                    </div>
                                    <div
                                      style={{
                                        fontSize: "14px",
                                        padding: "5px",
                                        borderRadius: "50px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        textAlign: "center",
                                        margin: "0px 5px 0px 15px",
                                      }}
                                    >
                                      (
                                      {
                                        getFilteredCities(state).filter(
                                          (area) => area.is_serviceable
                                        ).length
                                      }
                                      /{getFilteredCities(state).length} &nbsp;
                                      <span>serviceable cities</span>)
                                    </div>

                                    <div style={{ marginLeft: "auto" }}>
                                      {expandedStates[state] ? (
                                        <FaChevronUp size={15} />
                                      ) : (
                                        <FaChevronDown size={15} />
                                      )}
                                    </div>
                                  </div>
                                </td>
                              </tr>

                              {expandedStates[state] && (
                                <>
                                  <tr>
                                    <td
                                      colSpan="4"
                                      className="nested-table-cell"
                                    >
                                      <table className="city-table">
                                        <thead>
                                          <tr>
                                            <th className="cityClass">City</th>
                                            <th>City Code</th>
                                            <th>Serviceability</th>
                                            <th>Delivery Charge</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {getFilteredCities(state).map(
                                            (area, idx) => (
                                              <tr
                                                key={idx}
                                                onMouseEnter={() =>
                                                  setHoveredCity(
                                                    `${state}-${area.city}`
                                                  )
                                                }
                                                onMouseLeave={() =>
                                                  setHoveredCity(null)
                                                }
                                                style={{ cursor: "default" }}
                                              >
                                                <td>
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    {showBulkEditPanel ? (
                                                      <Form.Check
                                                        type="checkbox"
                                                        className="custom-dark-checkbox"
                                                        onChange={() =>
                                                          handleCheckboxChange(
                                                            state,
                                                            area.city
                                                          )
                                                        }
                                                        checked={
                                                          area.is_serviceable ||
                                                          selectedCities.includes(
                                                            `${state}-${area.city}`
                                                          )
                                                        }
                                                        style={{
                                                          marginRight: "10px",
                                                          cursor: "pointer",
                                                        }}
                                                        disabled={
                                                          showBulkEditPanel ===
                                                          "delivery"
                                                            ? !area.is_serviceable
                                                            : area.is_serviceable
                                                        }
                                                      />
                                                    ) : (
                                                      <span
                                                        style={{
                                                          width: "20px",
                                                          display:
                                                            "inline-block",
                                                        }}
                                                      />
                                                    )}
                                                    <span>{area.city}</span>
                                                  </div>
                                                </td>
                                                <td>{area.city_code}</td>
                                                <td>
                                                  <div
                                                    className="servClass"
                                                    onClick={() =>
                                                      updateServiceability(
                                                        area.city_code
                                                      )
                                                    }
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                  >
                                                    {area.is_serviceable ? (
                                                      <FaToggleOn
                                                        size={25}
                                                        color="green"
                                                      />
                                                    ) : (
                                                      <FaToggleOff
                                                        size={25}
                                                        color="#cd3e3e"
                                                      />
                                                    )}
                                                  </div>
                                                </td>
                                                <td
                                                  style={
                                                    {
                                                      // display: "flex",
                                                      // alignItems: "center",
                                                      // padding: "18px 15px",
                                                    }
                                                  }
                                                >
                                                  {editingCity ===
                                                  `${state}-${area.city}` ? (
                                                    <>
                                                      <input
                                                        type="number"
                                                        min="0"
                                                        value={
                                                          cityDeliveryCharges[
                                                            `${state}-${area.city}`
                                                          ] ?? ""
                                                        }
                                                        onChange={(e) => {
                                                          const value =
                                                            e.target.value;
                                                          if (
                                                            value === "" ||
                                                            Number(value) >= 0
                                                          ) {
                                                            setCityDeliveryCharges(
                                                              {
                                                                ...cityDeliveryCharges,
                                                                [`${state}-${area.city}`]:
                                                                  value,
                                                              }
                                                            );
                                                          }
                                                        }}
                                                        style={{
                                                          width: "70px",
                                                          marginRight: "10px",
                                                        }}
                                                      />

                                                      {pendingSave ===
                                                        `${state}-${area.city}` && (
                                                        <FaCheck
                                                          color="green"
                                                          style={{
                                                            marginLeft: "10px",
                                                            cursor: "pointer",
                                                          }}
                                                          onClick={() => {
                                                            const newCharge =
                                                              cityDeliveryCharges[
                                                                `${state}-${area.city}`
                                                              ];
                                                            if (
                                                              newCharge ===
                                                                "" ||
                                                              Number(
                                                                newCharge
                                                              ) < 0
                                                            ) {
                                                              toast.error(
                                                                "Delivery charge cannot be negative or empty."
                                                              );
                                                              return;
                                                            }
                                                            handleUpdateCityDeliveryCharge(
                                                              state,
                                                              area.city,
                                                              area.city_code
                                                            );
                                                            setEditingCity(
                                                              null
                                                            );
                                                            setPendingSave(
                                                              `${state}-${area.city}`
                                                            );
                                                            setTimeout(
                                                              () =>
                                                                setPendingSave(
                                                                  null
                                                                ),
                                                              2000
                                                            );
                                                          }}
                                                        />
                                                      )}
                                                    </>
                                                  ) : (
                                                    <>
                                                      {area.is_serviceable ? (
                                                        <>
                                                          {
                                                            area.delivery_charges
                                                          }
                                                          {hoveredCity ===
                                                            `${state}-${area.city}` && (
                                                            <FaPen
                                                              style={{
                                                                marginLeft:
                                                                  "10px",
                                                                cursor:
                                                                  "pointer",
                                                              }}
                                                              onClick={() => {
                                                                handleEdit(
                                                                  state,
                                                                  area.city,
                                                                  area.delivery_charges
                                                                );
                                                                setPendingSave(
                                                                  `${state}-${area.city}`
                                                                );
                                                              }}
                                                            />
                                                          )}
                                                        </>
                                                      ) : (
                                                        <>
                                                          {area.delivery_charges ||
                                                            0}
                                                        </>
                                                      )}
                                                    </>
                                                  )}
                                                </td>
                                              </tr>
                                            )
                                          )}
                                        </tbody>
                                      </table>
                                    </td>
                                  </tr>
                                </>
                              )}
                            </React.Fragment>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="6" style={{ padding: "10px 15px" }}>
                              No serviceable areas added.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </>
              ) : modalState === "import_active" ? (
                <>
                  <label class="custum-file-upload" for="file">
                    <div class="icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill=""
                        viewBox="0 0 24 24"
                      >
                        <g stroke-width="0" id="SVGRepo_bgCarrier"></g>
                        <g
                          stroke-linejoin="round"
                          stroke-linecap="round"
                          id="SVGRepo_tracerCarrier"
                        ></g>
                        <g id="SVGRepo_iconCarrier">
                          {" "}
                          <path
                            fill=""
                            d="M10 1C9.73478 1 9.48043 1.10536 9.29289 1.29289L3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8V20C3 21.6569 4.34315 23 6 23H7C7.55228 23 8 22.5523 8 22C8 21.4477 7.55228 21 7 21H6C5.44772 21 5 20.5523 5 20V9H10C10.5523 9 11 8.55228 11 8V3H18C18.5523 3 19 3.44772 19 4V9C19 9.55228 19.4477 10 20 10C20.5523 10 21 9.55228 21 9V4C21 2.34315 19.6569 1 18 1H10ZM9 7H6.41421L9 4.41421V7ZM14 15.5C14 14.1193 15.1193 13 16.5 13C17.8807 13 19 14.1193 19 15.5V16V17H20C21.1046 17 22 17.8954 22 19C22 20.1046 21.1046 21 20 21H13C11.8954 21 11 20.1046 11 19C11 17.8954 11.8954 17 13 17H14V16V15.5ZM16.5 11C14.142 11 12.2076 12.8136 12.0156 15.122C10.2825 15.5606 9 17.1305 9 19C9 21.2091 10.7909 23 13 23H20C22.2091 23 24 21.2091 24 19C24 17.1305 22.7175 15.5606 20.9844 15.122C20.7924 12.8136 18.858 11 16.5 11Z"
                            clip-rule="evenodd"
                            fill-rule="evenodd"
                          ></path>{" "}
                        </g>
                      </svg>
                    </div>
                    {!importedFile ? (
                      <>
                        <div class="text">
                          <span>Click to upload File</span>
                        </div>
                      </>
                    ) : (
                      <>{importedFile.name}</>
                    )}
                    <input
                      type="file"
                      className="form-control"
                      id="file"
                      // accept={["xlsx", "xls", "csv"]
                      //   .map(function (x) {
                      //     return "." + x;
                      //   })
                      //   .join(",")}
                      onChange={(e) => handleImport("file_upload", e)}
                    />
                  </label>
                  <div className="serviceable_location_modal_footer mt-4">
                    <button
                      onClick={() => handleModalToggle()}
                      className="btn btn-danger"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={downloadSampleCSV}
                      className="btn btn-secondary"
                    >
                      Download Sample CSV
                    </button>
                    <button
                      onClick={() => handleImport("imported")}
                      className="btn"
                      style={{ background: "#0DCAF0C7", color: "white" }}
                    >
                      Import
                    </button>
                  </div>
                </>
              ) : modalState === "import_summary" ? (
                <>
                  <div className="table_variable_content">
                    <Table striped bordered hover responsive>
                      {importedLocationsSummary?.uploadedData?.map(
                        (row, index) => (
                          <tr key={index}>
                            {row.map((data, colIndex) => (
                              <React.Fragment key={colIndex}>
                                {index === 0 ? (
                                  <th>{data}</th>
                                ) : (
                                  <td
                                    style={
                                      colIndex === row.length - 1
                                        ? {
                                            color:
                                              data === "passed"
                                                ? "green"
                                                : "red",
                                          }
                                        : {}
                                    }
                                  >
                                    {data || data === 0 ? data : " "}
                                  </td>
                                )}
                              </React.Fragment>
                            ))}
                          </tr>
                        )
                      )}
                    </Table>
                    {importedLocationsSummary?.error && (
                      <div className="alert alert-warning">
                        {importedLocationsSummary.error}
                      </div>
                    )}
                  </div>

                  <div className="serviceable_location_modal_footer mt-4">
                    <button
                      onClick={() => handleImport("back_to_upload")}
                      className="btn btn-danger"
                    >
                      Do u want to upload Again?
                    </button>
                    <span style={{ color: "green", fontWeight: "bold" }}>
                      passed: {safeImportedLocationsSummary.passed}
                    </span>
                    <span
                      style={{
                        color: "red",
                        fontWeight: "bold",
                        marginLeft: "10px",
                      }}
                    >
                      failed: {safeImportedLocationsSummary.failed}
                    </span>

                    {importedLocationsSummary.passed != 0 ? (
                      <button
                        onClick={() => handleImport("validated")}
                        className="btn btn-primary"
                      >
                        Upload Passed Locations
                      </button>
                    ) : (
                      <span></span>
                    )}
                  </div>
                </>
              ) : (
                <>Something Went Wrong</>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ServicabilitySettings;
